import type { CustomFieldColumns } from 'v5/core/entity-values/values.types';

/**
 * Builds the columns a custom-field codec emits: every writable column is
 * present, `null` where the kind does not use it.
 */
export function customFieldColumns(
  partial: Partial<CustomFieldColumns>
): CustomFieldColumns {
  return {
    string_value: null,
    integer_value: null,
    float_value: null,
    boolean_value: null,
    date_value: null,
    option_id: null,
    multi_select_ids: null,
    raw_value: null,
    raw_unit: null,
    ...partial
  };
}
